import { useReveal } from "@/hooks/useReveal";

const MICHAL_PHOTO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_talent-ikra/artifacts/73eukyd7_ja.jpeg";

const MILENA_PHOTO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_talent-ikra/artifacts/ksgaqef7_Milenka.jpeg";

const TEAM = [
  {
    id: "milena",
    photo: MILENA_PHOTO,
    position: "center top",
    name: "Milena",
    role: "Rekrutacja · Administracja",
    lines: [
      "Cześć, jestem Milena. Prowadzę codzienną administrację naszego biura tu, na miejscu w Białymstoku, i odpowiadam za szukanie nowych talentów do Ikry.",
      "Jeśli aplikujesz na jakąkolwiek rolę, najpewniej to ja odezwę się do Ciebie jako pierwsza.",
      "Uwielbiam poznawać nowe osoby, więc zadzwoń, napisz albo po prostu wpadaj do biura. Nie mogę się doczekać, aż pogadamy.",
    ],
  },
  {
    id: "michal",
    photo: MICHAL_PHOTO,
    name: "Michał",
    role: "Właściciel",
    lines: [
      "Cześć, jestem Michał. Zaczynałem około 4 lata temu jako ambasador marki i dziś jestem dumnym właścicielem Ikry.",
      "Pasjonują mnie ludzie i rozwój. Poza pracą lubię sport i gry komputerowe.",
      "Naprawdę lubię to, co robię, i najbardziej cieszy mnie dzielenie się szansą z innymi. Ciekawi Cię, co mamy do zaoferowania? Wpadaj do biura, kiedy chcesz, jestem tu praktycznie codziennie.",
    ],
  },
];

export default function MeetTheTeam() {
  return (
    <section
      id="zespol"
      data-testid="team-section"
      className="relative py-24 lg:py-36 bg-[var(--ikra-bg)] border-t border-[var(--ikra-line)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--ikra-gold)] flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[var(--ikra-gold-bright)]" />
            Poznaj zespół
          </div>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[var(--ikra-ink)] uppercase">
            Ludzie, z którymi{" "}
            <span className="text-[var(--ikra-gold)]">zaczniesz</span>.
          </h2>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {TEAM.map((m, i) => (
            <Member key={m.id} m={m} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Member({ m, i }) {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`team-member-${m.id}`}
      className="reveal group relative overflow-hidden rounded-2xl border border-[var(--ikra-line)] bg-[var(--ikra-bg-alt)] hover:border-[var(--ikra-gold)] transition-colors duration-500"
      style={{ animationDelay: `${i * 120}ms` }}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-black">
        {m.photo ? (
          <img
            src={m.photo}
            alt={m.name}
            loading="lazy"
            style={m.position ? { objectPosition: m.position } : undefined}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[var(--ikra-bg-deep)] via-[var(--ikra-bg-alt)] to-[var(--ikra-bg-deep)]">
            <div
              aria-hidden
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(circle at 50% 40%, rgba(255,199,44,0.10), transparent 60%)",
              }}
            />
            <div className="relative flex items-center justify-center h-40 w-40 rounded-full border border-[var(--ikra-gold)]/40">
              <span className="font-display text-7xl text-[var(--ikra-gold)]">
                {m.initial}
              </span>
            </div>
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/90 to-transparent" />
      </div>

      <div className="p-7 lg:p-9">
        <div className="text-[10px] uppercase tracking-[0.24em] text-[var(--ikra-gold)]">
          {m.role}
        </div>
        <h3 className="mt-3 font-display text-2xl lg:text-3xl text-[var(--ikra-ink)] tracking-tight">
          {m.name}
        </h3>
        <span className="mt-4 inline-block h-px w-10 bg-[var(--ikra-gold)]" />
        <div className="mt-6 space-y-3 text-[15px] text-[var(--ikra-muted)] leading-relaxed">
          {m.lines.map((line, idx) => (
            <p key={idx}>{line}</p>
          ))}
        </div>
      </div>
    </article>
  );
}
